/**
 * @name parseDecimal
 * @category Locale Helpers
 * @summary Parses the match result into decimal number.
 *
 * @description
 * Parses the match result into decimal number.
 * Uses the string matched with the first set of parentheses of match RegExp.
 *
 * @param {Array} matchResult - the object returned by matching function
 * @returns {Number} the parsed value
 *
 * @example
 * locale.match = {
 *   ordinalNumbers: (dirtyString) {
 *     return String(dirtyString).match(/^(\d+)(th|st|nd|rd)?/i)
 *   },
 *   ordinalNumber: parseDecimal
 * }
 */
export default function parseDecimal (matchResult) {
  return parseInt(matchResult[1], 10)
}



//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/locale/_lib/parseDecimal/index.js
// module id = hcob
// module chunks = 52